<template>
  <IconBase
    :width="iconSize"
    :height="iconHeight"
    :view-box="`0 0 108 94`"
    icon-color="transparent"
  >
    <IconNotificationThanksPath />
  </IconBase>
</template>

<script>
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconNotificationThanksPath from "@/common/components/icons/IconNotificationThanksPath.vue";

export default {
  components: {
    IconBase,
    IconNotificationThanksPath
  },

  props: {
    iconSize: {
      type: Number,
      default: 108
    }
  },

  computed: {
    iconHeight() {
      const { iconSize } = this;
      const iconSizeObject = {
        92: 80,
        108: 94,
        231: 201
      };
      return iconSizeObject[iconSize];
    },

    iconComponent() {
      const { iconSize } = this;
      return `icon-notification-thanks-${iconSize}px`;
    }
  }
};
</script>
